import BubbleSort from "../pages/Algorithms/sorting/BubbleSort";
import SelectionSort from "../pages/Algorithms/sorting/SelectionSort";

export const AlgorithmsRoutes = [
  { path: "/bubble-sort", name: "ReactJS", component: BubbleSort },
  { path: "/selection-sort", name: "ReactJS", component: SelectionSort },
];
